<div id="userOrderDetail" class="userorderDetail-container ya-typography">
  <ya-subheader [hasContent]="false"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop" (swiperight)="swipeRightHandler()">
    <ng-container *ngIf="orderDetailViewModel">
      <div class="location-detail-image-wrapper">
        <div class="aspect-ratio-box">
          <div class="aspect-ratio-box-inside">
            <div class="aspect-ration-img-box">
              <img class="ya_image" [src]="image_photo" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="service-location-container">
        <div class="service-location">
          <h2>{{orderDetailViewModel.loc_label_de}}</h2>
          <span>{{orderDetailViewModel.loc_street}}</span>
          <span>{{orderDetailViewModel.loc_zip + " " + orderDetailViewModel.loc_city}}</span>
        </div>
      </div>
      <ng-container *ngIf="isremoteGroupOrder(orderDetailViewModel.order_type)">
        <ng-container *ngIf="hasContent(orderDetailViewModel.groupName)">
          <div class="group-info">
            <h2>{{setGroupNameLabel(orderDetailViewModel.groupName)}}</h2>
          </div>
        </ng-container>
      </ng-container>
      <div class="order-content">
        <div class="order-information">
          <div class="col-left">
            <h5 langkey="phUserOrderDetail_Date_Time"> </h5>
            <span>{{orderDetailViewModel.order_at}}</span>
            <h5 langkey="phUserOrderDetail_Order_Service"></h5>
            <span>{{OrderTypeLabel(orderDetailViewModel.order_type)}}</span>
            <h5 langkey="phUserOrderDetail_State"></h5>
            <span
              [langkey]="orderDetailViewModel.process_completed ? 'phUserOrderDetail_State_Done' : 'phUserOrderDetail_State_In_Progress'"></span>
          </div>
          <div class="col-right">
            <h5 langkey="phUserOrderDetail_Payment_Type"></h5>
            <span [langkey]="paymentLabel"></span>
            <h5 langkey="phUserOrderDetail_Order_Nr"></h5>
            <span>{{orderDetailViewModel.id}}</span>
          </div>
        </div>
        <div class="order-item-container">
          <div class="item-divider">
            <ng-container
              *ngIf="!isremoteGroupOrder(orderDetailViewModel.order_type)then DefaultSingleOrder  else RemoteGroupOrderDetail"></ng-container>
            <!-- Default Single Order-->
            <ng-template #DefaultSingleOrder>
              <div class="order-item-header article_price">
                <h5 langkey="phUserOrderDetail_Item_Header"></h5>
                <h5 langkey="phUserOrderDetail_Price_Header"></h5>
              </div>
              <ng-container *ngFor="let orderitem of  orderDetailViewModel.items">
                <div class="order-item-content">
                  <div class="orderitem-content-detail">
                    <div class="order-item-count-label">
                      <div class="item-count"> <span>{{orderitem.count +'x ' + orderitem.name}}</span></div>
                    </div>
                    <ng-container
                      *ngIf="isBenefitItem(orderitem.bonusactionId, orderitem.benefitId) then BenefitLabel else PriceLabel">
                    </ng-container>
                    <ng-template #PriceLabel>
                      <span>{{FormatCurrency(orderitem.price)}}</span>
                    </ng-template>
                    <ng-template #BenefitLabel>
                      <span langkey="phWebshop_Item_Benefit"></span>
                    </ng-template>
                  </div>
                  <ng-container *ngIf="ExtraItems()">
                    <ng-container *ngFor="let extra of orderitem.extras">
                      <p>{{extra.count +'x '+ extra.name}} </p>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </ng-template>
            <!-- Group order-->
            <ng-template #RemoteGroupOrderDetail>
              <ng-container *ngIf="hasMembers() then Members else NoMembers"></ng-container>
              <ng-template #Members>
                <ng-container *ngFor="let member of memberEntries; let i = index">
                  <div class="group-member-content" [ngClass]="{'content-border': hasNextContent(i)}">
                    <!-- Member name & sum-->
                    <div class="order-item-header">
                      <h5>{{ member.name }}</h5>
                      <h5>{{calculateTotalMemberAmount(member.id) }}</h5>
                    </div>
                    <!-- Header (Article / Price)-->
                    <div class="order-item-header header--margin">
                      <h5 langkey="phUserOrderDetail_Item_Header"></h5>
                      <h5 langkey="phUserOrderDetail_Price_Header"></h5>
                    </div>
                    <!-- list of member items-->
                    <ng-container *ngIf="groupMemberItems(member.id).length>0">
                      <ng-container *ngFor="let orderitem of groupMemberItems(member.id);">
                        <div class="order-item-content">
                          <div class="orderitem-content-detail">
                            <div class="order-item-count-label">
                              <div class="item-count"> <span>{{orderitem.count +'x ' + orderitem.name}}</span></div>
                            </div>
                            <span>{{FormatCurrency(orderitem.price)}}</span>
                          </div>
                          <ng-container *ngIf="ExtraItems()">
                            <ng-container *ngFor="let extra of orderitem.extras">
                              <p>{{extra.count +'x '+ extra.name}} </p>
                            </ng-container>
                          </ng-container>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-template>
              <ng-template #NoMembers>
                <div class="order-item-header article_price">
                  <h5 langkey="phUserOrderDetail_Item_Header"></h5>
                  <h5 langkey="phUserOrderDetail_Price_Header"></h5>
                </div>
                <ng-container *ngFor="let orderitem of  orderDetailViewModel.items">
                  <div class="order-item-content">
                    <div class="orderitem-content-detail">
                      <div class="order-item-count-label">
                        <div class="item-count"> <span>{{orderitem.count +'x ' + orderitem.name}}</span></div>
                      </div>
                      <span>{{FormatCurrency(orderitem.price)}}</span>
                    </div>
                    <ng-container *ngIf="ExtraItems()">
                      <ng-container *ngFor="let extra of orderitem.extras">
                        <p>{{extra.count +'x '+ extra.name}} </p>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-template>
            </ng-template>
          </div>
          <ng-container *ngIf="orderDetailViewModel.isDeliveryFee || orderDetailViewModel.isTip">
            <div class="non-standart-content">
              <ng-container *ngIf="orderDetailViewModel.isDeliveryFee">
                <div class="order-item-content non-standart-content_item">
                  <div class="orderitem-content-detail">
                    <div class="item-label"> <span langkey="phGlobal_DeliveryFee"></span> </div>
                    <span>{{FormatCurrency(orderDetailViewModel.delivery_fee)}}</span>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="orderDetailViewModel.isTip">
                <div class="order-item-content non-standart-content_item">
                  <div class="orderitem-content-detail">
                    <div class="item-label"><span langkey="phWebshop_Shippingcart_tip"></span></div>
                    <span>{{FormatCurrency(orderDetailViewModel.tip)}}</span>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <div class="order-total order-item-header">
            <h5 langkey="phGlobal_Total"></h5>
            <h5>{{FormatCurrency(orderDetailViewModel.payment_amount)}}</h5>
          </div>
        </div>
      </div>
      <ng-container *ngIf="orderDetailViewModel.isNoCoo">
        <div class="nocoo-container">
          <div class="nocoo-pin-container">
            <h5 langkey="phUserOrderDetail_NoCOO_Pin"></h5>
            <h5 class="nocoo-pin">{{orderDetailViewModel.nocoo_pin}}</h5>
          </div>
          <span langkey="phUserOrderDetail_NoCOO_Pin_Info_Label"> </span>
        </div>
        <div class="ya-webshop-button-container download-button">
          <button mat-flat-button (click)="NavigateToNoCoo()">
            <span langkey="phUserOrderDetail_Billing_Button_Label"></span></button>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>